// extracted by mini-css-extract-plugin
export default {"product_images":"ProductImages_product_images__gFAS3","img":"ProductImages_img__2NXQm"};